import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";
import { addProject } from "../state-management/actions/project-actions";
import {
  setAlert,
  setAlertSeverity,
  setAlertContext,
} from "../state-management/actions/alerts-actions";
import ProjectComponent from "../components/project";
import { ProjectDataProps } from "../types/public";
import { createNotificationData } from "../utils/createNotificationData";
import { addNotification } from "../state-management/actions/notification-actions";

export default function AddProject() {
  const dispatch = useDispatch();
  const { currentUserData, departmentsData, groupingData } =
    useSelector(selectGlobalState);
  const initialData: ProjectDataProps = {
    title: "",
    department_id: "",
    content: "",
    description: "",
    created_by: currentUserData._id,
    index_picture: "",
    index_video: "",
    pdf: {},
    tags: "",
    start_date: undefined,
    end_date: "",
    is_completed: false,
    is_active: false,
  };

  const [formData, setFormData] = useState<ProjectDataProps>(initialData);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const data = {
      ...formData,
      start_date: formData.start_date?.format
        ? formData.start_date?.format("YYYY-MM-DD")
        : undefined,
      tags:
        typeof formData.tags === "string"
          ? formData.tags.split("،").map((tag: string) => tag.trim())
          : [],
    };
    try {
      setLoading(true);
      const response = await addProject(data)(dispatch);
      if (response.data) {
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext("ثبت پروژه با موفقیت صورت پذیرفت"));
        setFormData(initialData);
        setLoading(false);
        const notificationData = createNotificationData({
          data,
          departmentsData,
          currentUserData,
          groupingData,
          type: "create",
          subject: "پروژه",
        });
        await addNotification(notificationData)(dispatch);
      } else {
        throw new Error("invalid response structure");
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <ProjectComponent
      handleSubmit={handleSubmit}
      formData={formData}
      setFormData={setFormData}
      currentUserId={currentUserData._id}
      loading={loading}
    />
  );
}
